'use strict';

var angular = require('angular');
var JQXGridDataAdapterFactory = function JQXGridDataAdapterFactory(ConfigurationLoaderService, JQXGridCustomSortService) {
  function getGridDataAdapter(gridSettings, data, dataBeforeRefresh) {
    var gridId = gridSettings.gridId;
    var sortCriteria = gridSettings.sortCriteria;
    var jqxSortCriteria = sortCriteria.toJQXSortCriteria();
    var dataFields = gridSettings.isDynamic ? gridSettings.dynamicFields : ConfigurationLoaderService.getGridDataFields(gridId).fields;
    var source = {
      datafields: dataFields,
      sortcolumn: jqxSortCriteria.columns,
      sortdirection: jqxSortCriteria.directions,
      datatype: 'array',
      localdata: data,
      originaldata: data,
      $dataBeforeRefresh: dataBeforeRefresh
    };
    source.sort = JQXGridCustomSortService.getCustomSorter(source, gridId);
    return new angular.element.jqx.dataAdapter(source);
  }
  return {
    getGridDataAdapter: getGridDataAdapter
  };
};
JQXGridDataAdapterFactory.$inject = ['ConfigurationLoaderService', 'JQXGridCustomSortService'];
module.exports = JQXGridDataAdapterFactory;